/*
 * @Author: your name
 * @Date: 2021-09-06 09:14:12
 * @LastEditTime: 2021-09-24 10:21:53
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\workOrder\api.js
 */
export const api = {
  workOrder: {
    // queryWorkerList: '/cms/account/queryResultsByPag.json', //查询权限人员
    queryWorkerList: '/cms/workgroup/querySecurityWorkGroupTree.json', //查询工作组
    updateWorkerList: '/bms/workorder/updateWorkOrderRight.json', //权限设置
    queryWorkOrderAuthGroup: '/bms/workorder/queryWorkOrderAuthGroup.json', //查询权限
    getWorkerList: '/bms/workorder/queryWorkOrderRight.json', //查询已经权限信息

    queryWorkOrderWorkGroup: '/bms/workorder/queryWorkOrderWorkGroup.json', //查询工单工作组
    addWorkOrderWorkGroup: '/bms/workorder/addWorkOrderWorkGroup.json', //add工单工作组
    updateWorkOrderWorkGroup: '/bms/workorder/updateWorkOrderWorkGroup.json', //update工单工作组
    deleteWorkOrderWorkGroup: '/bms/workorder/deleteWorkOrderWorkGroup.json', //delete工单工作组

    queryWorkOrderTemplateList: '/bms/workorder/queryWorkOrderTemplateList.json', //查询工单模板
    queryWorkOrderTemplate: '/bms/workorder/queryWorkOrderTemplate.json', //查询工单模板详情--特殊字段
    addWorkOrderTemplate: '/bms/workorder/addWorkOrderTemplate.json', //新增工单模板信息
    updateWorkOrderTemplate: '/bms/workorder/updateWorkOrderTemplate.json', //修改工单模板信息
    deleteWorkOrderTemplate: '/bms/workorder/deleteWorkOrderTemplate.json', //删除工单模板信息接口
    upFile: '/common/file/batchFileload.json', //图片上传
    queryWorkOrderFieldList: '/bms/workorder/queryWorkOrderFieldList.json', //查询工单字段信息
    queryWorkOrderList: '/bms/workorder/queryWorkOrderList.json', //查询工单列表信息
    updateWorkOrderField: '/bms/workorder/updateWorkOrderField.json', //编辑工单字段信息
    addWorkOrder: '/bms/workorder/addWorkOrder.json', //新增工单信息
    fixWorkOrder: '/bms/workorder/updateWorkOrderInfo.json', //编辑工单信息
    exportList: '/bms/workorder/exportWorkOrderList.json', //导出工单信息

    // queryResultsByPag: '/cms/account/queryResultsByPag.json', //查询账户列表---执行人
    queryResultsByPag: '/cms/account/queryResultsByPagApi.json', //查询账户列表---执行人
    queryPersonnelVehicleList: '/vas/personnel/queryPersonnelVehicleList.json', // 查询人员列表
    deleteWorkOrder: '/bms/workorder/deleteWorkOrder.json', //删除工单信息
    deleteWorkOrderField: '/bms/workorder/deleteWorkOrderField.json', //删除工单字段信息
    queryWorkOrderFlowList: '/bms/workorder/queryWorkOrderFlowList.json', //查询工单流程信息
    addWorkOrderFlow: '/bms/workorder/addWorkOrderFlow.json', //新增工单流程信息
    queryWorkOrderDetail: '/bms/workorder/queryWorkOrderDetail.json', //查询工单详细信息
    approvalWorkOrder: '/bms/workorder/approvalWorkOrder.json', //审批工单信息
    queryWorkGroupByAreaOrDevice: 'cms/workGroup/queryWorkGroupByAreaOrDevice.json', //资产巡检人员查询接口
    updateWorkOrder: '/bms/workorder/updateWorkOrder.json', //结束工单流程信息
    queryWorkOrderNoticeTemplate: '/bms/workorder/queryWorkOrderNoticeTemplate.json',// 查询工单的通知消息模板

    // 工单类型
    addWorkOrderType: '/bms/workorder/addWorkOrderType.json', //新增工单类型信息接口
    queryWorkOrderType: '/bms/workorder/queryWorkOrderTypeList.json', //查询工单类型信息接口
    delWorkOrderType: '/bms/workorder/deleteWorkOrderType.json', //删除工单类型信息接口
    updateWorkOrderType: '/bms/workorder/updateWorkOrderType.json', //编辑工单类型信息接口
    updateWorkOrderFlow: '/bms/workorder/updateWorkOrderFlow.json', //编辑工作流
    updateWorkOrderTemp: '/bms/workorder/updateWorkOrderTemplateExternalInfo.json', //修改工单模板其他信息接口
    queryPersonnelOrAccount: '/cms/workgroup/queryPersonnelOrAccount.json',//查询人员
    queryRelationWorkOrderDetail: '/bms/workorder/queryRelationWorkOrderDetail.json',//文本字段搜索
    queryWorkOrderFieldAccount: '/bms/workorder/queryWorkOrderFieldAccount.json',//工单字段展示
    updateWorkOrderFieldAccount: '/bms//workorder/updateWorkOrderFieldAccount.json',//update工单字段展示
  }
}
